// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__RXMV5","productName":"Table_productName__1wfNx"};